import type { Patient, Reference } from '@medplum/fhirtypes'
import type { ExtendedObservation } from '@seen/core/models/observation'
import type { ObservationCaptureTarget } from '#src/components/rich-text-editor/ObservationNode/types.ts'

export const CHOOSE_PARTICIPANT = 'Choose a participant to record'

// Whether a node's record belongs to someone other than whom the editor now
// records for (`null`: no one). Unknown either way counts as theirs.
export function isForeignRecord(
  observation: ExtendedObservation | undefined,
  recordFor: Reference<Patient> | null | undefined
): boolean {
  const subject = observation?.subject?.reference
  if (!subject || recordFor === undefined) {
    return false
  }
  return subject !== recordFor?.reference
}

// Whom a capture records for: `null` when no participant is chosen.
export function captureRecordFor(
  capture: ObservationCaptureTarget
): Reference<Patient> | null | undefined {
  return capture.noParticipant ? null : capture.participant
}
